var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "bairun-absolute-container bairun-bianlidian-target" },
    [
      _c(
        "el-header",
        { staticClass: "bairun-header" },
        [
          _c(
            "div",
            { staticClass: "search-term" },
            [
              _c(
                "el-form",
                { attrs: { inline: true } },
                [
                  _c(
                    "el-popover",
                    {
                      directives: [
                        {
                          name: "mobile",
                          rawName: "v-mobile",
                          value: true,
                          expression: "true"
                        }
                      ],
                      attrs: { placement: "right-end", trigger: "click" },
                      model: {
                        value: _vm.showSelSeller,
                        callback: function($$v) {
                          _vm.showSelSeller = $$v
                        },
                        expression: "showSelSeller"
                      }
                    },
                    [
                      _vm.sellerOptions.length > 1
                        ? _c(
                            "el-radio-group",
                            {
                              staticClass: "bairun-search-sellers",
                              attrs: { size: "mini" },
                              on: { change: _vm.onSubmit },
                              model: {
                                value: _vm.searchInfo.sellerId,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchInfo, "sellerId", $$v)
                                },
                                expression: "searchInfo.sellerId"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { label: 0, border: "" } },
                                [_vm._v("总")]
                              ),
                              _vm._l(_vm.sellerOptions, function(item) {
                                return _c(
                                  "el-radio",
                                  {
                                    attrs: { label: item.sellerId, border: "" }
                                  },
                                  [_vm._v(_vm._s(item.shortSellerName))]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        { attrs: { slot: "reference" }, slot: "reference" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("getSellerShortName")(
                                _vm.searchInfo.sellerId
                              )
                            )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.sellerOptions.length > 1
                    ? _c(
                        "el-radio-group",
                        {
                          directives: [
                            {
                              name: "mobile",
                              rawName: "v-mobile",
                              value: false,
                              expression: "false"
                            }
                          ],
                          staticClass: "bairun-search-sellers",
                          attrs: { size: "mini" },
                          on: { change: _vm.onSubmit },
                          model: {
                            value: _vm.searchInfo.sellerId,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "sellerId", $$v)
                            },
                            expression: "searchInfo.sellerId"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 0, border: "" } }, [
                            _vm._v("总")
                          ]),
                          _vm._l(_vm.sellerOptions, function(item) {
                            return _c(
                              "el-radio",
                              { attrs: { label: item.sellerId, border: "" } },
                              [_vm._v(_vm._s(item.shortSellerName))]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      _vm._v(" 月份： "),
                      _c("el-date-picker", {
                        attrs: {
                          type: "month",
                          format: "yyyy-MM",
                          "value-format": "yyyy-MM-dd 00:00:00",
                          placeholder: "选择月份",
                          clearable: false
                        },
                        on: { change: _vm.onMonthChange },
                        model: {
                          value: _vm.searchInfo.dateTime,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "dateTime", $$v)
                          },
                          expression: "searchInfo.dateTime"
                        }
                      })
                    ],
                    1
                  ),
                  ["qushi"].includes(_vm.checkTab)
                    ? _c(
                        "div",
                        [
                          _vm._v(" 日期： "),
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd 00:00:00",
                              placeholder: "日期选择",
                              clearable: false,
                              "picker-options": _vm.startTimePickerOptions
                            },
                            on: { change: _vm.onSubmit },
                            model: {
                              value: _vm.searchInfo.startTime,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "startTime", $$v)
                              },
                              expression: "searchInfo.startTime"
                            }
                          }),
                          _vm._v("- "),
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd 23:59:59",
                              placeholder: "日期选择",
                              clearable: false,
                              "picker-options": _vm.endTimePickerOptions
                            },
                            on: { change: _vm.onSubmit },
                            model: {
                              value: _vm.searchInfo.endTime,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "endTime", $$v)
                              },
                              expression: "searchInfo.endTime"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          !_vm.mubiaoSettingFinished
            ? _c("el-alert", {
                staticClass: "bairun-margin-t",
                attrs: { title: "温馨提示：当月目标未完成配置", type: "error" }
              })
            : _vm._e()
        ],
        1
      ),
      _c("el-main", { staticClass: "bairun-main" }, [
        _c("div", { staticClass: "bairun-padding" }, [
          _c(
            "div",
            { staticClass: "divider-title" },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.onCheckTab },
                  model: {
                    value: _vm.checkTab,
                    callback: function($$v) {
                      _vm.checkTab = $$v
                    },
                    expression: "checkTab"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "month" } }, [
                    _vm._v("月度")
                  ]),
                  _c("el-radio-button", { attrs: { label: "date" } }, [
                    _vm._v("日均")
                  ]),
                  _c("el-radio-button", { attrs: { label: "qushi" } }, [
                    _vm._v("趋势")
                  ])
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.checkTab === "month",
                      expression: "checkTab === 'month'"
                    }
                  ],
                  staticClass: "right"
                },
                [
                  _vm.type === ""
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "mini", icon: "el-icon-edit" },
                          on: { click: _vm.onEditMubiao }
                        },
                        [_vm._v("编辑")]
                      )
                    : _vm._e(),
                  _vm.type === "editMubiao"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "bairun-margin-l",
                          attrs: { size: "mini" },
                          on: { click: _vm.onCancelMubiao }
                        },
                        [_vm._v("取消")]
                      )
                    : _vm._e(),
                  _vm.type === "editMubiao"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.onSaveMubiao }
                        },
                        [_vm._v("保存")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-download"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onDownload(6)
                        }
                      }
                    },
                    [_vm._v("下载")]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.checkTab === "date",
                      expression: "checkTab === 'date'"
                    }
                  ],
                  staticClass: "right"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-download"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onDownload(12)
                        }
                      }
                    },
                    [_vm._v("下载")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "month",
                  expression: "checkTab === 'month'"
                }
              ],
              staticClass: "bairun-margin-t"
            },
            [
              _c(
                "el-table",
                {
                  ref: "mubiaoTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.mubiaoTable.table,
                    "show-summary": "",
                    "summary-method": _vm.getMonthSummaries
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "便利店", prop: "sellerName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.sellerName))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "月目标营业额", prop: "targetAmount" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm.type === "editMubiao"
                              ? _c("el-input-number", {
                                  staticClass: "mubiao-input",
                                  attrs: {
                                    placeholder: "请输入",
                                    min: 0,
                                    controls: false
                                  },
                                  model: {
                                    value: scope.row.targetAmount,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "targetAmount", $$v)
                                    },
                                    expression: "scope.row.targetAmount"
                                  }
                                })
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row.targetAmount))
                                ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "月实际营业额", prop: "tradeAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "月完成率", prop: "completePercent" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-progress", {
                              staticClass: "bairun-progress",
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 15,
                                percentage: parseInt(
                                  scope.row.completePercent * 100
                                ),
                                status:
                                  parseInt(scope.row.completePercent * 100) >=
                                  100
                                    ? "primary"
                                    : "warning"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "date",
                  expression: "checkTab === 'date'"
                }
              ],
              staticClass: "bairun-margin-t"
            },
            [
              _c(
                "el-table",
                {
                  ref: "dateAvgTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.dateAvgTable.table,
                    "show-summary": "",
                    "summary-method": _vm.getDateAvgSummaries
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "便利店", prop: "sellerName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.sellerName))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "日均目标营业额", prop: "targetAmount" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.saleTargetAveragePerDay
                                    .totalAveragePerDayTargetAmount
                                ) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "日均实际营业额", prop: "tradeAmount" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.saleTargetAveragePerDay
                                    .totalAveragePerDayTradeAmount
                                ) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "日均完成率", prop: "completePercent" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-progress", {
                              staticClass: "bairun-progress",
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 15,
                                percentage: parseInt(
                                  scope.row.saleTargetAveragePerDay
                                    .totalAveragePerDayCompletePercent * 100
                                ),
                                status:
                                  parseInt(
                                    scope.row.saleTargetAveragePerDay
                                      .totalAveragePerDayCompletePercent * 100
                                  ) >= 100
                                    ? "primary"
                                    : "warning"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "日均目标差距", prop: "tradeAmount" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.saleTargetAveragePerDay
                                    .totalAveragePerDayDiffAmount
                                ) +
                                " "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "qushi",
                  expression: "checkTab === 'qushi'"
                }
              ],
              staticClass: "bairun-margin-t"
            },
            [
              _c("div", {
                staticClass: "bairun-margin-t",
                staticStyle: { width: "100%", height: "30rem" },
                attrs: { id: "echartsQuShi" }
              })
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }